var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 1.875C7.988 1.875 7.70817 2.15483 7.70817 2.5V3.125H4.1665C3.82133 3.125 3.5415 3.40482 3.5415 3.75C3.5415 4.09518 3.82133 4.375 4.1665 4.375H15.8332C16.1783 4.375 16.4582 4.09518 16.4582 3.75C16.4582 3.40482 16.1783 3.125 15.8332 3.125H12.2915V2.5C12.2915 2.15483 12.0117 1.875 11.6665 1.875H8.33317Z",
    fill: "#201E2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8841 12.4997L12.1087 13.7244C12.3528 13.9685 12.3528 14.3642 12.1087 14.6082C11.8647 14.8523 11.469 14.8523 11.2249 14.6082L10.0002 13.3836L8.77541 14.6082C8.53133 14.8523 8.13564 14.8523 7.89156 14.6082C7.64748 14.3642 7.64748 13.9685 7.89156 13.7244L9.11624 12.4997L7.89155 11.2749C7.64748 11.0308 7.64748 10.6352 7.89155 10.3911C8.13563 10.147 8.53133 10.147 8.77541 10.3911L10.0002 11.6157L11.2249 10.3911C11.469 10.147 11.8647 10.147 12.1087 10.3911C12.3528 10.6352 12.3528 11.0308 12.1087 11.2749L10.8841 12.4997Z",
    fill: "#201E2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99267 6.59798C5.02784 6.28145 5.29538 6.04199 5.61385 6.04199H14.3858C14.7042 6.04199 14.9718 6.28145 15.007 6.59798L15.1737 8.09909C15.4761 10.8202 15.4761 13.5664 15.1737 16.2875L15.1573 16.4353C15.0373 17.5154 14.2001 18.3767 13.1239 18.5274C11.0513 18.8176 8.94832 18.8176 6.87572 18.5274C5.79943 18.3767 4.96232 17.5154 4.8423 16.4353L4.82588 16.2875C4.52353 13.5664 4.52353 10.8202 4.82588 8.09909L4.99267 6.59798ZM6.17325 7.29199L6.06823 8.23713C5.77608 10.8665 5.77608 13.5202 6.06823 16.1495L6.08465 16.2972C6.14158 16.8095 6.53858 17.218 7.04903 17.2895C9.00665 17.5635 10.993 17.5635 12.9506 17.2895C13.4611 17.218 13.8581 16.8095 13.915 16.2972L13.9314 16.1495C14.2236 13.5202 14.2236 10.8665 13.9314 8.23713L13.8264 7.29199H6.17325Z",
    fill: "#201E2A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.91cc4ae5e04701f8b8bc8234625cabf2.svg";
export { ForwardRef as ReactComponent };